module.exports = __webpack_public_path__ + "img/logo.d48574cd.png";